module.exports = __webpack_public_path__ + "img/access.b9925038.jpg";